<template>
  <div class style="overflow: hidden">
    <iframe
      id="menu-iframe"
      :width="iframeWidth"
      :height="iframeHeight"
      :src="menuIframeUrl"
      frameborder="0"
      scrolling="auto"
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      menuIframeUrl: `${process.env.VUE_APP_NEWMENU}?lang=${this.$store.getters.appLang}`,
      iframeWidth: "800px",
      iframeHeight: "0px",
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight
    };
  },
  mounted() {
    const that = this;

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
        window.screenHeight = document.body.clientHeight;
        that.screenHeight = window.screenHeight;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.handleIframeSize();
          that.timer = false;
        }, 400);
      }
    },
    screenHeight(val) {
      if (!this.timer2) {
        this.screenWidth = val;
        this.timer2 = true;
        let that = this;
        setTimeout(function() {
          that.handleIframeSize();
          that.timer2 = false;
        }, 400);
      }
    }
  },
  methods: {
    handleIframeSize() {
      let headerHeight = 75;
      let cutWidth = 0;

      let innerWidth =
        window.innerWidth || document.documentElement.clientWidth;
      let innerHeight =
        window.innerHeight || document.documentElement.clientHeight;

      let top = 0;
      let left = 260;
      // console.log('check ' + innerWidth)
      if (innerWidth < 1000) {
        // console.log('update the left');
        left = 0;
      }

      this.iframeWidth = innerWidth - left - cutWidth;
      this.iframeHeight = innerHeight - top - headerHeight;
      // console.log('the innerWidth is ' + innerWidth);
      // console.log('the left is ' + left);
      // console.log('the cutWidth is ' + cutWidth);
    }
  },
  
  computed: {
    ...mapGetters([
      'appLang',
    ]),
  },

  watch: {
    appLang: {
      handler(newVal, oldVal) {
        if (!newVal)
          return;
        this.$set(this, 'menuIframeUrl', `${process.env.VUE_APP_NEWMENU}?lang=${newVal}`);
      }
    }
  },

  created() {
    this.handleIframeSize();
    // let headerHeight = 75;
    // let cutWidth = 0;
    // let innerWidth = window.innerWidth || document.documentElement.clientWidth;
    // let innerHeight = window.innerHeight || document.documentElement.clientHeight;
    // let top = 0;
    // let left = 260;
    // this.iframeWidth = innerWidth - left - cutWidth;
    // this.iframeHeight = innerHeight - top - headerHeight;
  }
};
</script>
<style>
</style>


